import { isEmpty, sortBy, reverse } from 'lodash-es';
import React from 'react';
import LockIcon from '@/assets/images/menu/lock-on.react.svg?react';
import { MultiApp } from '@/config/context';
import i18n from '@/i18n';
import { ENV } from '@/infrastructure/env-config';
import { getCapitalPlatform, isAndroid } from '@/infrastructure/product-info';
import { CapitalPlatform } from '@/infrastructure/utils/app';
// import { stores } from '../store';
import { ProductType } from '@/service/product-permissions';
import { stores } from '../store';
import { IRouteConfig } from './types';

// @ts-ignore
const entriesContext = import.meta.webpackContext('./entries/', {  regExp: /.ts(x)?$/ });
// @ts-ignore
const overlaysContext = import.meta.webpackContext('./overlays/', {  regExp: /.ts(x)?$/ });

const generateRoutes = (context: any) => {
  let routes: IRouteConfig[] = [];
  context.keys().forEach((item: any) => {
    const module: any = context(item);
    const route = module.default?.() ?? [];

    routes = routes.concat(route);
  });
  return routes;
};

const entriesRoutes = generateRoutes(entriesContext);
const overlaysRoutes = generateRoutes(overlaysContext);

/**
 * 路由表
 * 参数说明：
 * @hideInMenu 侧边栏入口是否隐藏，默认 false
 * @disabled 是否禁用，默认 false
 * @whitelisted 白名单，默认 false
 * @enabledMultiApps 哪个版本展示 string[]
 * @latforms 哪个平台展示
 * @excludePatforms 哪个平台不展示
 * @versions 哪个版本展示
 */
const deepFilterRoutes = (routes: IRouteConfig[]): IRouteConfig[] => {
  const platform = getCapitalPlatform() as CapitalPlatform;
  const version = ENV.currentAppVersion as MultiApp;

  const { productType } = stores.ProductStore;

  const res = routes.map((route, index) => {
    // 没配sort的 按写的顺序排, 因为用到了翻转，所以排前面的值越小
    const sort = route.sort ? route.sort : (routes.length - index);
    const originalName = route.name;
    const name = typeof originalName === 'string' ? i18n.t(originalName) : originalName;
    let extra = (productType === ProductType.FREE_PRODUCT && route.disabledByFree) ? <LockIcon /> : undefined ;
    if (originalName === 'ANR' && !isAndroid() && productType === ProductType.FREE_PRODUCT) {
      extra = <LockIcon />;
    }
    if (route.routes) {
      return {
        ...route,
        name,
        sort,
        extra,
        routes: deepFilterRoutes(route.routes),
      };
    }

    return { ...route, name, sort, extra };
  }).filter((route) => {
    const { platforms = [], versions = [], excludePlatforms = [], validator } = route;

    // 会员权限校验
    // const authed = !authName || authorityNodes.includes(authName);
    // const authed = true;

    const matchExcludePlatforms = isEmpty(excludePlatforms) || !excludePlatforms.includes(platform);
    const matchPlatforms = isEmpty(platforms) || platforms.includes(platform);
    const matchVersion = isEmpty(versions) || versions.includes(version);
    const validate = !validator || validator(route);

    return matchExcludePlatforms && matchPlatforms && matchVersion && validate;
    // return authed && matchExcludePlatforms && matchPlatforms && matchVersion && validate;
  });

  return reverse(sortBy(res, 'sort'));
};

export const getRoutes = () => deepFilterRoutes([...entriesRoutes, ...overlaysRoutes]);
export const getEntriesRoutes = () => deepFilterRoutes(entriesRoutes);
export const getOverlaysRoutes = () => deepFilterRoutes(overlaysRoutes);
